<template>
    <modal @close="close" dialog="modal-lg" class="reservation-modal payment dark-top">
        <div slot="title">
            <h2>{{title}}</h2>
        </div>

        <div slot="body" class="bg-lighter">
            <div class="w-100 px-4 pt-4 bg-lightest">
                <div class="col-sm-12 d-flex flex-row justify-content-between">
                    <label>Select payment method</label>
                    <label>Amount<span class="color-6 bold">*</span></label>
                </div>

                <div class="col-sm-12 mt-3 pb-2">
                    <div class="row">
                        <div class="col-sm-9 d-flex flex-row flex-wrap">
                            <payment-method-picker v-model="payment.type" />
                        </div>

                        <div v-if="getIsLoadingCalculations" class="col-sm-3 d-flex justify-content-center">
                            <loader></loader>
                        </div>

                        <div v-else class="col-sm-3 d-flex align-items-start">
                            <div class="d-flex flex-row align-items-center w-100">
                                <input
                                    type="text"
                                    min="0"
                                    step="0.01"
                                    class="fs-largest flex-grow-1 text-right bg-lighter glued-right"
                                    v-model.number="formattedPaymentValue"
                                    style="width: 100px;"
                                    placeholder="0.00"
                                >
                                <div class="border-light glued-left fs-largest py-2 px-2">€</div>
                                <span v-if="direction == 0"> <!-- Only for pay ins-->
                                    <i v-if="!payment.value || payment.value == 0" class="ico ico-add fs-large light mr-0 ml-3 pointer"></i>
                                    <i v-else class="ico ico-add fs-large color-1 mr-0 ml-3 pointer" @click="addThisPayment()"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 d-flex align-items-end mb-2 justify-content-end">
                    <div>
                        <label class="mr-3">
                            <span v-if="totalDue >= 0">
                                <span v-if="reservation.changeStatusTo == '-5' || reservation.changeStatusTo == '-6'">Value to refund</span>
                                <span v-else>Due to Pay</span>
                            </span>
                            <span v-if="totalDue < 0">Over Pay</span>
                        </label>
                        <span v-if="getReservationCreation" class="fs-large font-weight-600 pointer" @click="copyValueToInput(formatPrice(outstandingAmout - valueOfPaymentsInMemory))" :class="{'color-6': ( outstandingAmout - valueOfPaymentsInMemory ) < 0, 'color-3': ( outstandingAmout - valueOfPaymentsInMemory ) == 0 }">{{ formatPrice(outstandingAmout - valueOfPaymentsInMemory ) }} €</span>
                        <span v-else class="fs-large font-weight-600 pointer" @click="copyValueToInput(formatPrice(totalDue - valueOfPaymentsInMemory))" :class="{'color-6': (totalDue - valueOfPaymentsInMemory) < 0, 'color-3': (totalDue - valueOfPaymentsInMemory) == 0 }">{{ formatPrice(totalDue - valueOfPaymentsInMemory ) }} €</span>

                        <label class="mx-3">
                            Total
                        </label>
                        <span class="fs-large font-weight-600 pointer" @click="copyValueToInput(formatPrice(getReservationCalculations.grandTotal))">{{ formatPrice(getReservationCalculations.grandTotal) }} €</span>
                    </div>
                </div>

                <div class="col-sm-12 row mx-0 px-0 py-2 border-top-light">
                    <div v-if="direction == 1" class="col-sm-12 d-flex align-items-center mb-2">
                        <label class="mr-2">
                            Payout reason<span class="color-6 bold">*</span>
                        </label>
                        <v-select :options="getPayoutReasons" :disabled="false" label="text" placeholder="Select reason" v-model="selectedReason" @input="reasonChanged"></v-select>
                    </div>

                    <div class="col-sm-12 d-flex align-items-center">
                        <label class="mr-2">
                            Notes
                        </label>
                        <input type="text" class="w-100" v-model="payment.description">
                    </div>
                </div>

                <ul v-if="paymentsInMemory.length != 0" class="bg-lighter p-2 m-2 mb-3 radius-normal" style="border: 1px solid rgb(197, 208, 222);list-style-type: disc; padding-left: 40px !important;">
                    <strong style="margin-left: -28px;margin-bottom: 5px;display: block;">Parceled payments:</strong>
                    <li v-for="payment, i in paymentsInMemory" :key="i">
                        <span v-html="parceledPaymentRow(payment)"></span>
                        <i @click="$delete(paymentsInMemory, i)" class="fa fa-times fs-large light ml-2 pointer"></i>
                     </li>
                </ul>
            </div>
        </div>

        <div slot="footer">
            <button type="button" class="btn cancel widest" @click="cancel">Cancel</button>
            <button type="button" class="btn ok widest" :disabled="disabledSaveBtn" @click="save(false)">Save</button>
            <button v-if="getReservationCreation" type="button" class="btn blue ok widest" :disabled="disabledSaveBtn" @click="save(true)">Save and print</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import Modal from './Modal'
    import extendedVSelect from '@/extends/vue-select'
    import PrintJs from 'print-js'
    import TeamMemberPicker from '../TeamMemberPicker'
    import Loader from '@/tools/loaders/loader1'
    import paymentMethodPicker from '@/tools/PaymentMethodPicker'
    import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
    data() {
        return {
            selectedReason: null,
            payment: {
                type: 1,
                id: 0,
                value: null,
                currency: "€",
                paymentDirection: 0, // This will be changed on mounted()
                treasurerUserAccount: null, // We can save the treasurer as an agent or supplier or user account
                description: ''
            },
            paymentsInMemory: [],
            tempBilling: {
                promoCode: "",
                promoCodeDiscountType: null,
                promoCodeDiscountCode: null,
                discountType: 0,
                discountValue: 0,
                description: "",
                details: {
                    vat: "",
                    businessName: "",
                    address: "",
                    city: "",
                    country: 176
                },
                invoices: null,
                payments: [
                    {
                        type: 1,
                        value: null,
                        currency: "€",
                        description: null
                    }
                ]
            },
            tresurerArr:[],
            selectedTresurer: null,
            treasurerSupplier: null,
            showBillingDetails: true,
            showNotes: false,
            selectedCountry: null,
            clickedSave: false,
            clickedSaveAndPrint: false,
        }
    },
    validations: {
        payment:{
            value: {
                required,
                higherThanZero: (value) => value > 0
            },
        }
    },
    props: {
        direction: {
            default: 0,
            type: Number
        },
    },
    mounted() {
        this.payment.paymentDirection = this.direction;
    },
    created() {
        this.payment.treasurerUserAccount = this.account;

        //set tresurer as me
        this.selectedTresurer = this.tresurerMe;

        if (this.getReservationCreation) {
            this.payment.value = this.outstandingAmout - this.valueOfPaymentsInMemory;
        }
    },
    mixins: [
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservationCreation',
            'getSelectedReservation',
            'getReservation',
            'getCountries',
            'account',
            'getReservationCalculations',
            'getIsSavingReservation',
            'getPaymentTypeListAll',
            'getIsAddingReservation',
            'getIsLoadingCalculations',
            'getPayoutReasons',
            'getShowInvoiceOption'
        ]),
        hasInvoiceSystem() {
            return this.getShowInvoiceOption;
        },
        formattedPaymentValue: {
            get() {
                return this.payment.value != null ? this.payment.value.toFixed(2) : '';
                },
            set(newVal) {
                const parsed = parseFloat(newVal);

                this.$set(this.payment, 'value', isNaN(parsed) ? 0 : parsed);
            }
        },
        tresurerMe() {
            let me = JSON.parse(JSON.stringify(this.account));
            me.name = me.name + ' (Me)';
            
            return me;
        },
        valueOfPaymentsInMemory() {
            // return the sum of all payments in memory (parceled Payments)
            return this.paymentsInMemory.reduce( (acc, obj) => {return acc + Number(obj.value);}, 0);
        },
        title() {
            return this.payment.paymentDirection == 0? 'Pay In' : 'Pay Out';
        },
        reservation() {
            if (this.getReservationCreation) {
                return this.getReservation;
            }
            
            return this.getSelectedReservation;
        },
        disabled() {
            return false;
        },
        totalInPyamentOptions() {
            let total = 0;

            for(let paymentOption of this.tempBilling.payments){
                total += Number(paymentOption.value);
            }

            return total;
        },
        outstandingAmout() {
            return this.getReservationCalculations.grandTotal - this.totalInPyamentOptions;
        },
        disabledSaveBtn() {
            if (this.getReservationCreation) {
                // Old condition in reservation creation. Always enabled, except when a reservation is being added (sometimes you may need to save reservation with no payment)
                if (!this.getIsAddingReservation) {
                    return false;
                } else {
                    return true;
                }
            } else {
                if (this.paymentsInMemory.length != 0) {
                    return false;
                } else if(this.$v.$invalid) {
                        return true;
                } else {
                    if (this.direction == 1 && this.payment.paymentReasonType === null) {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
    },
    methods: {
        ...mapActions([
            'createNewReservation',
            'closeModal',
            'printInvoice',
            'addFloatingNotification',
            'unsetReservationCreation'
        ]),
        cancel() {
            this.unsetReservationCreation();
            this.close();
        },
        close() {
            this.closeModal();
        },
        paymentType(payment) {
            if (payment) {
                const paymentType = this.getPaymentTypeListAll.find(p => p.id == payment.type).description;
                
                return paymentType;
            } else {
                return 'Something wrong here...';
            }
        },
        parceledPaymentRow(payment) {
            const notes = (payment.description != null && payment.description != '') ? ` - (Notes: ${payment.description}).` : '.';
            
            return `${payment.value}<strong>${payment.currency} - ${this.paymentType(payment)}${notes}</strong>`;
        },
        addThisPayment() {
            const paymentToAdd = JSON.parse(JSON.stringify(this.payment));

            this.paymentsInMemory.push(paymentToAdd);

            // Reset payment to its original value
            this.payment.value = null;
            this.payment.description = null;

            this.$forceUpdate();
        },
        save(print) {
            const { grandTotalDepositValueRequired } = this.getReservationCalculations;
            this.saveLastCustomerDetails();

            this.payment.date = moment().format("YYYY-MM-DD HH:mm:00");

            // Payments in Memory (parceled payments), on reservation Edit
            let savePaymentsInMemory = (targetReservation) => {
                let allPayments;

                const checkForPaymentInInputAnPushIt = (payment) => {
                    // If we have payment (single payment) in the input and if the value is not 0 or null, inject it
                    if (payment.value !== null && payment.value !== 0 && payment.value !== '') { 
                        allPayments.push(payment);
                    }
                }

                if (targetReservation.billing.payments == null) {
                    // Put the new payment/s array
                    allPayments = [...this.paymentsInMemory];
                    checkForPaymentInInputAnPushIt(this.payment);
                } else {
                    allPayments = [...this.paymentsInMemory];
                    checkForPaymentInInputAnPushIt(this.payment);
                }

                // SET PAYMENTS
                targetReservation.billing.payments = allPayments;
            }

            // Single Payment, on reservation Edit
            let saveSinglePayment = (targetReservation) => {
                if (!targetReservation.billing.payments || targetReservation.billing.payments == null) {
                    this.$set(targetReservation.billing, 'payments', []);
                }
                // Add row to billing payemnts list to help with calculations
                if (!this.getReservationCreation && (targetReservation.billing.payments === undefined || targetReservation.billing.payments === null) ) {
                    this.$set(targetReservation.billing, 'payments', []);
                }
                targetReservation.billing.payments.push(this.payment);
            }

            // Reusable variable function to insert Parceled payments OR single payment
            // Based on the nature of the reservation (creating new one OR editing)
            let proccessPayment = (targetReservation) => {
                // Parceled payments OR single payment
                if (this.paymentsInMemory.length != 0) { // payments in memory (parceled)
                    savePaymentsInMemory(targetReservation);
                } else {
                    // No payments in memory (parceled), it's EMPTY []
                    saveSinglePayment(targetReservation);
                }
            }

            const getTotalPayments = (reservation) => {
                return reservation.billing.payments.reduce((total, payment) => {
                    return payment.value ? total + payment.value : total;
                }, 0);
            };

            /*********************************************************************
             * Execution - SAVE the reservation payment/s based on some criteria *
             *********************************************************************/
            if (!this.getReservationCreation) {
                // ======================================================
                // Reservation EDIT mode, getReservationCreation == false
                // Target reservation = this.getSelectedReservation
                // ======================================================
                if (this.payment.value != null && this.payment.value > 0 || this.paymentsInMemory.length != 0) {
                    // Parceled payments OR single payment
                    proccessPayment(this.getSelectedReservation);
                    this.$set(this.getSelectedReservation.updateFlags, 'billing', true);

                     // Just to make sure
                    this.unsetReservationCreation();
                    this.$forceUpdate();
                    this.close();

                } else {
                    this.unsetReservationCreation();
                    this.close();
                }
            } else {
                // =========================================================
                // Reservation CREATION mode, getReservationCreation == true
                // Target reservation = this.getReservation
                // =========================================================
                if (this.getIsAddingReservation == true || this.clickedSaveAndPrint == true || this.clickedSave == true) {
                    this.$toasted.info('Already creating reservation, please wait.');
                    
                    return false;
                }

                if (print) {
                    this.clickedSaveAndPrint = true;
                } else {
                    this.clickedSave = true;
                }

                // Parceled payments OR single payment
                proccessPayment(this.getReservation);

                const paymentValue = getTotalPayments(this.getReservation);
                
                if (paymentValue >= grandTotalDepositValueRequired && grandTotalDepositValueRequired != null) {
                    this.createNewReservation({
                        supplierId: this.account.supplierId,
                        reservation: this.reservation
                    }).then(response => {
                        let vm = this;
                        this.clickedSave = false;
                        this.clickedSaveAndPrint = false;
                        if (response.status == 200) {
                            this.addFloatingNotification(
                                {
                                    type: -1,
                                    title: 'Ticket '+this.formatTicketNumber(response.data.id),
                                    message: response.data.customer.name+' <br>'+response.data.event.product.name,
                                    bookingId: response.data.id,
                                },
                                'info',
                                {
                                    link: '/reservations/view/'+response.data.id
                                }
                            )

                            this.$toasted.success('Reservation created successfully');
                            this.$router.push({ name: 'reservations' });
                            this.closeModal();

                            if (print) {
                                axios.get('/api/booking/GetTicket', {
                                    params: {
                                        supplierId: this.account.supplierId,
                                        bookingId: response.data.id,
                                        type: 'vertical'
                                    }
                                }).then(responseTicket => {
                                    this.openByteArrayNewTab(responseTicket.data);
                                })

                                // Print invoice
                                let referanceToMakeChanges = this.selectedSellerAccessList;
                                
                                if (response.data.bookingInvoices.length > 0 && response.data.bookingInvoices[0].id && hasInvoiceSystem) {
                                    vm.printInvoice(response.data.bookingInvoices[0].id).then(responsePrintInvoice => {
                                        if(responsePrintInvoice.status == 200){
                                            vm.openByteArrayNewTab(responsePrintInvoice.data);
                                        }
                                    }).catch(err => {});
                                }
                            }
                        }
                    }).catch(err => {
                        this.clickedSave = false;
                        this.clickedSaveAndPrint = false;
                    })
                } else {
                    this.$dialog.alert(`
                        <div class="d-flex flex-column justify-content-center">
                            <div class="fs-largest font-weight-600 mb-4">Minimum Payment Required</div>
                            <div class="dark">To complete your reservation, a minimum amount of <span class="bold darkest">${this.formatPrice(grandTotalDepositValueRequired)}€</span> is required. 
                                    Currently, you've only added <span class="bold darkest">${this.formatPrice(paymentValue)}€.</span></>
                            <div class="dark mt-3"> Please adjust the amount to proceed with the payment.</div>
                        </div>`,
                        { okText: 'Ok'}
                    ).then(() => {
                        this.clickedSave = false;
                        this.clickedSaveAndPrint = false;

                        this.$set(this.reservation.billing, 'payments', []);
                    });
                }
            }
        },
        copyValueToInput(value){
            const floatValue = parseFloat(value);

            this.$set(this.payment, 'value', floatValue < 0? floatValue * -1 : floatValue);
        },
        reasonChanged(e) {
            this.$set(this.payment, 'paymentReasonType', e.id);
        }
    },
    components: {
        Modal,
        vSelect: extendedVSelect,
        TeamMemberPicker,
        Loader,
        paymentMethodPicker
    },
}
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .payMethod {
        width: 103px;
        height: 72px;
        position: relative;

        .payeLabel {
            position: absolute;
            bottom: 7px;
            width: 100%;
        }

        &.selected {
            border-color: $darkest !important;
            border-width: 2px !important;
        }

        &:hover {
            background-color: $lighter;
        }
    }
</style>



// WEBPACK FOOTER //
// ReservationPayment.vue?438787a0